import React from "react";
import VersionLanding from "../../components/version/VersionLanding";

const Version = () => {
  return (
    <div>
      <VersionLanding />
    </div>
  );
};

export default Version;
